import { UserPasswordRepository } from "@/domain/repository/user-password-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class IssueWebFindSnLinkUsecase {
  constructor(private readonly userPasswordRepo: UserPasswordRepository) {}

  async execute(email: string): Promise<SATResult<void, SATError>> {
    return this.userPasswordRepo.issueWebFindSnLink({ email });
  }
}
